import React, { Component } from 'react'
import Card from '../../../components/Card/Card.jsx'
import AccountBox from '@material-ui/icons/AccountBox'
import Assignment from '@material-ui/icons/Assignment'
import CardBody from '../../../components/Card/CardBody.jsx'
import CardIcon from '../../../components/Card/CardIcon.jsx'
import CardHeader from '../../../components/Card/CardHeader.jsx'
import GridItem from '../../../components/Grid/GridItem.jsx'
import GridContainer from '../../../components/Grid/GridContainer.jsx'
import Button from '../../../components/CustomButtons/Button.jsx'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Spinner from 'react-spinner-material'
import Select from '@material-ui/core/Select'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Checkbox from '@material-ui/core/Checkbox'
import Check from '@material-ui/icons/Check'
import Subscriptions from '../../../components/Subscriptions/Subscriptions.jsx'
import backend from '../../../utils/backend'
import { showSuccessMessage, showErrorMessage } from '../../../components/Alerts/Alerts'
import { BackendError } from '../../../utils/errors'
import dot from 'dot-object'
import token from '../../../utils/token'
import uuid from 'uuid'
import crypto from 'crypto'
import * as constants from '../Account/constants'

class UserDetailsPage extends Component {
  state = {
    user: {app_metadata : {
      role: "Viewer",
      subscriptions: []
    }},
    prevUser: {app_metadata : {
      role: "Viewer",
      subscriptions: []
    }},
    viewMoreDetails: false,
    saveButtonLabel: 'Save',
    disableBackButton: false,
    disableResetPasswordButton: true,
    disableSendVerificationEmailButton: false,
    fetching: false,
    apiKey: '',
    apiKeyHash: '',
    apiKeyShown: '',
    hasExistingApiKey: false,
  }

  generateAPIKey = () => {
    const apiKey = uuid.v4()
    const apiKeyShown = apiKey
    const apiKeyHash = this.getAPIKeyHash(apiKey)
    this.setState({ apiKey, apiKeyShown, apiKeyHash })
  }

  getAPIKeyHash = apiKey => {
    if (apiKey) {
      return crypto
        .createHash('sha256')
        .update(apiKey)
        .digest('hex')
    }
  }

  maskAPIKey = () => {
    this.setState({ apiKeyShown: constants.MASK })
  }

  async componentDidMount() {
    this._isMounted = true
    const { id } = this.props
    let userToSetState
    if (!id) {
      const errorMessage = 'No user id selected'
      console.error(errorMessage)
      showErrorMessage(errorMessage)
    } else {
      try {
        userToSetState = await backend.get('users', id)
        if (userToSetState.data) userToSetState = userToSetState.data
        userToSetState.currentCompany = window.localStorage.getItem("selected-tenant")
        this.setState({
          user: userToSetState,
          disableResetPasswordButton: false
        })

        try {
          const keyInfo = await backend.getUserAPIKey(id)
          if (keyInfo && keyInfo.id) {
            this.setState({ hasExistingApiKey: true })
            this.maskAPIKey()
          }
        } catch (e) {
        }
      } catch (e) {
        console.error(e.message)
        return showErrorMessage(e.message)
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleChange = e => {
    if(e.target.name === 'app_metadata.subscriptions' && this.state.user.app_metadata.subscriptions && this.state.user.app_metadata.subscriptions.length >0) {
      return // this is to prevent overwriting the subscription array if it's not empty
    }
    this.setState({
      prevUser: JSON.parse(JSON.stringify(this.state.user)),
      user: dot.str(e.target.name, e.target.value, this.state.user)
    })
  }

  toggleMoreDetails = () => {
    this.setState({
      viewMoreDetails: !this.state.viewMoreDetails
    })
  }

  sendPasswordReset = async () => {
    try {
      const resBody = await backend.sendPasswordReset(this.state.user.email)
      if (resBody.error)
        throw new Error('Error sending password reset: ' + resBody.error)
      await showSuccessMessage(
        'Password reset mail sent. Please ask user to check email!'
      )
      this.setState({ disableResetPasswordButton: true })
    } catch (e) {
      showErrorMessage(e.message)
    }
  }

  sendVerificationEmail = async () => {
    try {
      await backend.sendVerificationEmail(this.state.user.email)
      await showSuccessMessage('Verification mail sent. Please ask user to check email!')
      this.setState({ disableSendVerificationEmailButton: true })
    } catch (e) {
      showErrorMessage(e.message)
    }
  }

  handleSave = async e => {
    try {
      let result = {}
      this.setState({
        disableBackButton: true,
        fetching: true,
        saveButtonLabel: 'Saving ... '
      })
      let body = this.state.user
      if (body.data) body = body.data

      // ! Use the prop ID, not the body ID to prevent ID manipulation
      body.id = this.props.id
      body.user_id = this.props.id

      // ! Validate that we have a proper user ID
      if (!this.props.id || this.props.id !== body.user_id) {
        throw new Error('User ID validation failed')
      }

      if (this.props.id) {
        result = await backend.update('users', body)
      } else {
        throw new Error('Cannot find user id')
      }

      this.setState({
        disableBackButton: false,
        fetching: false
      })

      if (result.code && result.code > 399) throw new BackendError(result)

      await showSuccessMessage('Your item has been saved!')
      this.props.goBack()
    } catch (e) {
      this.setState({
        user: this.state.prevUser,
        saveButtonLabel: 'Save',
        disableBackButton: false,
        fetching: false
      })
      showErrorMessage('Error while Saving: ' + e.message)

    }
  }

  handleSaveApiKey = async () => {
    try {
      const body = this.state.user.data || this.state.user

      await backend.postUserAPIKey({
        userId: this.props.id,
        apiKeyHash: this.state.apiKeyHash,
        role: body.app_metadata.role,
        email: body.email,
        companies: body.user_metadata.company ?
          (Array.isArray(body.user_metadata.company) ? body.user_metadata.company : [body.user_metadata.company])
          : []
      })

      await showSuccessMessage('API key has been saved!')
      this.setState({ hasExistingApiKey: true })
      this.maskAPIKey()
    } catch (e) {
      console.error('Error while Saving API key: ' + e.message)
      showErrorMessage('Error while Saving API key: ' + e.message)
    }
  }

  /**
   * ! Render role options based on acting user's permissions
   * @param {object} userData - The user data being edited
   * @returns {JSX.Element[]} Array of MenuItem components
   */
  renderRoleOptions = (userData) => {
    const actingUser = token.loadUserFromToken()
    const actingUserRole = actingUser?.role
    const currentUserRole = userData.app_metadata.role

    const options = []

    // Always show current role as disabled (can't change to same role)
    if (currentUserRole === 'SuperAdmin') {
      options.push(<MenuItem key="superadmin-current" value={'SuperAdmin'} disabled>SuperAdmin (Current)</MenuItem>)
    }
    if (currentUserRole === 'Admin') {
      options.push(<MenuItem key="admin-current" value={'Admin'} disabled>Admin (Current)</MenuItem>)
    }

    // Role assignment rules based on acting user's permissions
    if (actingUserRole === 'SuperAdmin') {
      // SuperAdmin can assign any role except to themselves
      if (currentUserRole !== 'SuperAdmin') {
        options.push(<MenuItem key="superadmin" value={'SuperAdmin'}>SuperAdmin</MenuItem>)
      }
      if (currentUserRole !== 'Admin') {
        options.push(<MenuItem key="admin" value={'Admin'}>Admin</MenuItem>)
      }
      options.push(<MenuItem key="editor" value={'Editor'}>Editor</MenuItem>)
      options.push(<MenuItem key="viewer" value={'Viewer'}>Viewer</MenuItem>)
      options.push(<MenuItem key="assetetter" value={'AssetSetter'}>Asset Setter</MenuItem>)
    } else if (actingUserRole === 'Admin') {
      // Admin can assign Editor/Viewer roles only
      options.push(<MenuItem key="editor" value={'Editor'}>Editor</MenuItem>)
      options.push(<MenuItem key="viewer" value={'Viewer'}>Viewer</MenuItem>)
      options.push(<MenuItem key="assetsetter" value={'AssetSetter'}>Asset Setter</MenuItem>)
    } else {
      // Non-admin users cannot change roles
      options.push(<MenuItem key="no-permission" value={currentUserRole} disabled>{currentUserRole} (No Permission)</MenuItem>)
    }

    return options
  }

  render() {
    const { classes, goBack } = this.props
    const {
      user,
      fetching,
      viewMoreDetails,
      saveButtonLabel,
      disableResetPasswordButton,
      disableBackButton,
      disableSendVerificationEmailButton,
      apiKey,
      apiKeyShown,
    } = this.state
    if(!user) return <p>loading...</p>
    const userData = user.data || user || null
    const actingUser = token.loadUserFromToken()
    const canManageApiKey = actingUser?.role === 'SuperAdmin' || actingUser?.id === userData.user_id
    return (
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <AccountBox />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>User Details</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={6}>
                <h5>User Details</h5>
                <TextField
                  id="nickname"
                  //label="Nickname"
                  type="search"
                  className={classes.textField}
                  margin="dense"
                  fullWidth
                  value={userData.nickname}
                  disabled={true}
                />
                <TextField
                  id="email"
                  //label="Email"
                  type="search"
                  className={classes.textField}
                  margin="dense"
                  fullWidth
                  value={userData.email}
                  disabled={true}
                />
                <div>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="role-label">
                      Role
                    </InputLabel>
                    <Select
                      value= {this.state.user.app_metadata.role || this.state.user.data.app_metadata.role}
                      onChange={this.handleChange}
                      input={<Input name="app_metadata.role" id="role-label" />}
                      displayEmpty={false}
                      name="app_metadata.role"
                      className={classes.selectEmpty}
                    >
                      <MenuItem value="" disabled>
                        <em>Role</em>
                      </MenuItem>
                      {/* ! Role options based on acting user's permissions */}
                      {this.renderRoleOptions(userData)}
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <h5>
                    View more details
                    <Checkbox
                      checked={viewMoreDetails}
                      tabIndex={-1}
                      onClick={this.toggleMoreDetails}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                    />
                  </h5>
                  {viewMoreDetails && (
                    <div>
                      <img src={userData.picture} alt={userData.nickname} />

                      <TextField
                        id="company"
                        label="Company"
                        type="search"
                        className={classes.textField}
                        margin="dense"
                        fullWidth
                        value={userData.currentCompany}
                        disabled={true}
                      />
                      <TextField
                        id="email_verified"
                        label="Email verified"
                        type="search"
                        className={classes.textField}
                        margin="dense"
                        fullWidth
                        value={userData.email_verified}
                        disabled={true}
                      />
                      <TextField
                        id="id"
                        label="ID"
                        type="search"
                        className={classes.textField}
                        margin="dense"
                        fullWidth
                        value={userData.user_id}
                        disabled={true}
                      />
                      <TextField
                        id="created_at"
                        label="Created at (UTC)"
                        type="search"
                        className={classes.textField}
                        margin="dense"
                        fullWidth
                        value={userData.created_at}
                        disabled={true}
                      />
                      <TextField
                        id="last_password_reset"
                        label="Last password reset (UTC)"
                        type="search"
                        className={classes.textField}
                        margin="dense"
                        fullWidth
                        value={userData.last_password_reset || 'None'}
                        disabled={true}
                      />
                      <TextField
                        id="last_login"
                        label="Last login (UTC)"
                        type="search"
                        className={classes.textField}
                        margin="dense"
                        fullWidth
                        value={userData.last_login || 'None'}
                        disabled={true}
                      />
                    </div>
                  )}
                </div>

              </GridItem>
              <GridItem xs={12} md={6}>

                <Subscriptions
                  subscriptions={userData.app_metadata.subscriptions || []}
                  classes={classes}
                  handleChange={this.handleChange}
                ></Subscriptions>
              </GridItem>
            </GridContainer>
            <Grid item xs={12} style={{marginTop:"30px"}}>
              <Button
                style={{ margin: '20px 10px' }}
                variant="contained"
                color="white"
                onClick={() => {
                  goBack()
                }}
                disabled={disableBackButton}
              >
                Back
              </Button>
              <Button
                style={{ margin: '20px 10px' }}
                variant="contained"
                color="success"
                onClick={this.handleSave}
              >
                <Spinner
                  size={12}
                  spinnercolor={'#FFF'}
                  spinnerwidth={2}
                  visible={fetching}
                />
                {saveButtonLabel}
              </Button>
              <Button
                style={{ margin: '20px 10px' }}
                variant="contained"
                color="warning"
                onClick={this.sendPasswordReset}
                disabled={disableResetPasswordButton}
              >
                Reset password
              </Button>
              <Button
                style={{ margin: '20px 10px' }}
                variant="contained"
                color="info"
                onClick={this.sendVerificationEmail}
                disabled={disableSendVerificationEmailButton}
              >
                Resend confirmation email
              </Button>

            </Grid>
          </CardBody>
        </Card>

        {canManageApiKey && (
          <Card style={{ marginTop: '20px' }}>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>API Key Settings</h4>
            </CardHeader>
            <CardBody>
              <TextField
                id="apiKey"
                label="API key"
                type="search"
                className={classes.textField}
                margin="dense"
                fullWidth
                value={apiKeyShown}
                disabled={true}
              />
              <Button
                style={{ margin: '20px 10px' }}
                variant="contained"
                color="warning"
                onClick={this.generateAPIKey}
              >
                Generate
              </Button>
              <Button
                style={{ margin: '20px 10px' }}
                variant="contained"
                color="success"
                onClick={this.handleSaveApiKey}
                disabled={!apiKey}
              >
                Save
              </Button>
              <GridContainer></GridContainer>
            </CardBody>
          </Card>
        )}
      </GridItem>
    )
  }
}

export default UserDetailsPage
